<template>
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-loan__tcustbase}">
        <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
          <el-form-item>
            <ren-dept-tree v-model="dataForm.companyId" :placeholder="$t('dept.title')" :query="true" ref="tree"></ren-dept-tree>
          </el-form-item>
          <el-form-item>
            <el-input v-model="dataForm.mobile" placeholder="手机号" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getDataList('dept')">{{ $t('query') }}</el-button>
          </el-form-item>
        
        </el-form>
        <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
          <!-- ok -->
          <!-- <el-table-column prop="licensee" label="持牌方" header-align="center" align="center"></el-table-column> -->
          <el-table-column prop="id" label="账号Id" header-align="center" align="center"></el-table-column>
         
          <el-table-column prop="deptName" label="机构名称" header-align="center" align="center"></el-table-column>
          <el-table-column prop="username" label="用户名称" header-align="center" align="center"></el-table-column>
           <!-- ok -->
          <el-table-column prop="mobile" label="联系手机号" header-align="center" align="center"></el-table-column>
          
          <!-- ok -->
          <el-table-column prop="userStatus" label="账户状态" header-align="center" align="center">
            <template slot-scope="scope">
              <div>
                {{scope.row.userStatus == 'NORMAL' ? '已开户' : '未开户'}}
              </div>
            </template>
          </el-table-column>
         
          <!-- ok -->
          <el-table-column prop="openDate" label="开户时间" header-align="center" align="center"></el-table-column>
           <!-- ok -->
          <el-table-column prop="txnSeqno" label="交易流水号" header-align="center" align="center"></el-table-column>
          
          <!-- ok -->
          <el-table-column prop="oidPartner" label="ACCP系统用户编号" header-align="center" align="center"></el-table-column>
          <!-- ok -->
          <el-table-column prop="accpTxno" label="ACCP系统交易单号" header-align="center" align="center"></el-table-column>
          <el-table-column prop="remark" label="失败原因" header-align="center" align="center"></el-table-column>
          
          <!-- <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
            <template slot-scope="scope">
              <el-button v-if="$hasPermission('loan:tcustbase:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
              <el-button v-if="$hasPermission('loan:tcustbase:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
            </template>
          </el-table-column> -->
        </el-table>
        <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
        </el-pagination>
      </div>
    </el-card>
  </template>
  
  <script>
  import mixinViewModule from '@/mixins/view-module'

  export default {
    mixins: [mixinViewModule],
    created(){
      console.log(this.dataForm.deptId)
    },
    data () {
      return {
        mixinViewModuleOptions: {
          //crm-jr-admin/sys/user/page
          getDataListURL: '/sys/user/page',
          // getDataListURL: '/loan/tcustbase/page',
          getDataListIsPage: true,
          exportURL: '/loan/tcustbase/export',
          deleteURL: '/loan/tcustbase',
          deleteIsBatch: true
        },
        userType:[],
        dataForm: {
          mobile:'',
          companyId:''
        }
      }
    },
    watch:{
      $route:{
        handler(newVal,odlVal){
          console.log(111)
          if(this.$refs.tree){
              this.$refs.tree.showDeptName = ''
            }
            this.dataForm.companyId = ''
            this.getDataList()
        },
        deep:true,
        immediate:true
      }
   },
  }
  </script>
  